import { DataSourceExecutionEvent, Snackbar } from "@mcleod/components";
import { Navigation, StringUtil } from "@mcleod/core";
import { AutogenLayoutDetentionTracking } from "./autogen/AutogenLayoutDetentionTracking";
import { getDetentionControlBoolean } from "@mcleod/general";

export class DetentionTracking extends AutogenLayoutDetentionTracking {

    onLoad(): void {
        this.visible = getDetentionControlBoolean("is_active", false);
    }

    freeTimeOnClick() {
        Navigation.navigateTo('lme/dispatch/DetentionHistoryList?status=F');
    }

    chargingOnClick() {
        Navigation.navigateTo('lme/dispatch/DetentionHistoryList?status=B');
    }

    occurredOnClick() {
        Navigation.navigateTo('lme/dispatch/DetentionHistoryList?status=D');
    }

    totalOnClick() {
        Navigation.navigateTo('lme/dispatch/DetentionHistoryList');
    }

    sourceDetentionProfileSearchBeforeExecution(event: DataSourceExecutionEvent) {
        if (!getDetentionControlBoolean("is_active", false)){
            event.stop();
            return;
        }
    }

    sourceDetentionHistoryLookupAfterExecution(event: DataSourceExecutionEvent) {
        const message = this.mainDataSource?.data[0]?.get("message");
        if (!StringUtil.isEmptyString(message)) {
            Snackbar.showWarningSnackbar(message);
        } else {
            this.labelTotalCount.text = this.mainDataSource.data.length.toString();
            this.labelFreeTimeCount.text = this.mainDataSource.data.filter((modelRow) => 
                "F" === modelRow.get("status")
            ).length.toString();
            this.labelChargingCount.text = this.mainDataSource.data.filter((modelRow) => 
                "B" === modelRow.get("status")
            ).length.toString();
            this.labelOccurredCount.text = this.mainDataSource.data.filter((modelRow) => 
                "D" === modelRow.get("status")
            ).length.toString();
        }
    }
}